import { useMemo } from 'react';
import DashboardBody from '../dashboard-body/dashboard-body';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import Resources from '@/components/resources/resources';
import HealthDataContent from '../../../health-data/components/health-data-content/health-data-content';
import { Tab, TabType } from '../../../health-data/types';
import { HealthDataHero } from '@/app/components/health-data/components/health-data-hero/health-data-hero';
import { FeatureFlags, useFeatureFlags } from '@/services/feature-flag-provider';
import { CatchLabsCTA } from '@/app/components/common/CatchLabsCTA';

function CatchLabsHero() {
  return (
    <div className="mb-6">
      <CatchLabsCTA />
    </div>
  );
}

interface UseDashboardTabsConfigProps {
  setParams: (params: Record<string, string>) => void;
}

export function useDashboardTabsConfig({ setParams }: UseDashboardTabsConfigProps) {
  const { isEnabled } = useFeatureFlags();
  const isCatchLabsEnabled = isEnabled(FeatureFlags.IsCatchLabsEnabled);

  const tabsConfig: Record<TabType, Tab> = useMemo(
    () => ({
      'risk-insights': {
        id: 'risk-insights' as TabType,
        label: 'Risk Insights',
        tabContent: (
          <DashboardBody>
            {isCatchLabsEnabled && <CatchLabsHero />}
            <Resources as="aside" width="full" />
          </DashboardBody>
        ),
      },
      'health-data': {
        id: 'health-data' as TabType,
        label: 'Health Data',
        tabContent: (
          <DashboardLayout>
            <DashboardGrid>
              <HealthDataContent setParams={setParams} />
              <Resources as="aside" width="full" />
            </DashboardGrid>
          </DashboardLayout>
        ),
        heroContent: <HealthDataHero/>,
      },
    }),
    [setParams, isCatchLabsEnabled],
  );

  return { tabsConfig };
}
